import React from "react";
import { Layout, Icon } from "antd";
import { connect } from "react-redux";
import { CreateCollapsedAction } from "../redux/Global";
const { Header } = Layout;

class Model extends React.Component {
  render() {
    return (
      <Header className="header">
        <div className="iconbox">
          <Icon
            className="trigger"
            type={this.props.collapsed ? "menu-unfold" : "menu-fold"}
            onClick={this.props.changeCollapsed}
          />
        </div>
      </Header>
    );
  }
}

export default connect(
  state => ({
    collapsed: state.Global.collapsed
  }),
  dispatch => ({
    changeCollapsed() {
      dispatch(CreateCollapsedAction());
    }
  })
)(Model);



// WEBPACK FOOTER //
// ./src/components/Header.jsx